const React = require('react');

const Content = require('./Content.jsx');
const _TypeConfig = require('./TypeConfig.jsx');
const Utilities = require('../utility/Utilities.jsx');

// #region V1

function Text(props) {
    let blockProps = {};
    if (props.config && props.config.Config && props.config.Config.Block) {
        blockProps = props.config.Config.Block;
    }
    return <Content.Value {...props} value={blockProps.displayText} />;
}
const TypeConfig = {
    panel: {
        block: function () {
            return {
                label: 'Block Configuration',
                options: [
                    _TypeConfig.options.firstPageOnly(),
                    { display: 'Label Properties', id: 'labelProps', type: 'header' },
                    {
                        display: 'Display Text',
                        name: 'displayText',
                        type: 'text',
                        value: 'Text'
                    },
                    { type: 'spacer' },
                    ..._TypeConfig.options.text({}, {})
                ]
            };
        },
        style: Content.TypeConfig.value.panel.style
    }
};

// #endregion V1

// #region V2

function TextV2(props) {
    let blockProps = {};
    if (props.config && props.config.config && props.config.config.Block) {
        blockProps = props.config.config.Block;
    }
    return <Content.Value {...props} value={blockProps.design} />;
}
const TypeConfigV2 = {
    panel: {
        block: () => {
            const group = 'block';
            return {
                group,
                label: 'Design',
                options: [
                    _TypeConfig.options.firstPageOnly(group),
                    {
                        display: 'Display Text',
                        fullWidth: true,
                        group,
                        name: 'design',
                        type: 'rich-text-collateral',
                        value: Utilities.wrapTextForEditor({ text: 'Text' })
                    }
                ]
            };
        },
        style: () => Content.TypeConfig.value.panel.styleV2('style')
    }
};

// #endregion V2

module.exports = {
    Component: Text,
    ComponentV2: TextV2,
    TypeConfig,
    TypeConfigV2
};